import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { selectedCycleIdState } from 'modules/pond/stores/atom'
import { useRecoilValue } from 'recoil'

import {
  saveSearchHistory,
  deleteSearchHistory,
} from './index'
import { useGetSearchHistory } from './queries'

export const useSaveSearchHistory = () => {
  const { refetch } = useGetSearchHistory()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation(['common'])

  return useMutation(saveSearchHistory, {
    onSuccess: async () => {
      enqueueSnackbar(t('common:edit.success'), { variant: 'success' })
      refetch()
    },
  })
}

export const useDeleteSearchHistory = () => {
  const { refetch } = useGetSearchHistory()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation(['common'])

  return useMutation(deleteSearchHistory, {
    onSuccess: async () => {
      enqueueSnackbar(t('common:edit.success'), { variant: 'success' })
      refetch()
    },
  })
}
